

































import { Component, Mixins, Prop } from "vue-property-decorator";

// Mixins
import AdminBrandId from "@/mixins/adminBrandId";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IUser } from "@/models/users";

@Component({
  components: {
    "timeline-component": () =>
      import("@/components/app/global/timelineComponent/index.vue")
  }
})
export default class AdminUsers extends Mixins(AdminBrandId) {
  @Prop({ default: () => () => [] })
  public routes!: () => any;

  public async createStaffUser() {
    if (!this.canCreate) return;

    try {
      this.$store.dispatch(`data/${DataModules.USERS}/openCreateModal`, {
        events: {
          success: ({ id: userId }: IUser) => {
            this.$store.dispatch("toast/show", {
              message: this.$t("_sentence.staff_user_successfully_created")
            });
            this.$router.push({ name: "adminUser", params: { userId } });
          }
        }
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
  }

  // Computed

  public get canCreate() {
    return this.$userCan("create_user");
  }
}
